import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-road',
  templateUrl: './road.component.html',
  styleUrls: ['./road.component.scss']
})
export class RoadComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
